import { ROUTE_PARTIES_ADD } from '@/common/constants';
import { Heading } from '@/components/heading/Heading';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePartyStore } from '../store/usePartyStore';
import { PartiesTable } from './parties-table';

export default function PartyWrapper() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const pageSize = Number(searchParams.get('size')) || 10;
  const currentPage = Number(searchParams.get('page')) || 1;
  const { fetchParties } = usePartyStore();

  useEffect(() => {
    fetchParties({ page: currentPage, size: pageSize });
  }, [currentPage, pageSize]);

  return (
    <div className="flex flex-col py-8 px-10 w-full  h-full space-y-6">
      <div className="flex-h-center-between">
        <Heading title={'parties'} />
        <Button
          variant="outline"
          className="text-gray-900 text-sm font-medium"
          onClick={() => navigate(ROUTE_PARTIES_ADD)}
        >
          <Plus size="20" color="green" />
          {t('add.parties')}
        </Button>
      </div>
      <PartiesTable />
    </div>
  );
}
